import { useMutation, useQueryClient } from '@tanstack/react-query';

import { actionItemCommentsKey } from '@pages/ActionItem/services/useActionItemCommentsQuery';
import { locationsAssetsKey } from '@pages/Sensors/services/useLocationsAssetsQuery';

import { actionItemKey } from '@services/actionItem/useActionItemQuery';
import { actionItemsGlobalOrIdListKey } from '@services/actionItem/useActionItemsGlobalOrIdListQuery';
import { apiClient } from '@services/apiClient';

const remindLaterFn = (data) => apiClient.post(`${APP_API_URL}remind-later`, data);

export const useRemindLaterMutation = ({ actionItemId }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: remindLaterFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: actionItemKey(actionItemId) });
      queryClient.invalidateQueries({ queryKey: [actionItemsGlobalOrIdListKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [locationsAssetsKey()[0]] });
      queryClient.invalidateQueries({ queryKey: actionItemCommentsKey(actionItemId) });
    },
  });
};
